import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['math_round'] = function (block: Blockly.Block): [string, number] {
        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        const op = block.getFieldValue('OP');

        const fnMap: Record<string, string> = {
            round: 'round',
            ceil: 'ceil',
            floor: 'floor',
        };

        return expr(`${fnMap[op]}(${value})`);
    };
}
